export default {"src":"/_next/static/media/brightness.2b94fb5f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};